// extracted by mini-css-extract-plugin
export default {"header":"menu_header__903Od","mainPage":"menu_mainPage__-PyBP"};